import { toast } from 'react-toastify';

import { callApi } from '../../../../apiCaller';
import { toastError } from '../../../../utils';
import { setIsLoading, setIsWaiting, setShowPopupDetail } from '../../../../actions/general';

const API_SYSTEM_CONTENT_MANAGEMENTS = 'universal';
const API_SYSTEM_CONTENT_MANAGEMENT = 'universal/:id';

export const ADD_ADMIN_CONTENT_MANAGEMENTS = 'addAdminContentManagements';
export const ADD_ADMIN_CONTENT_MANAGEMENT = 'addAdminContentManagement';
export const UPDATE_CONTENT_MANAGEMENT = 'updateAdminContentManagement';

// Get All
export const addSystemAdminContentManagements = (contentManagements) => {
     return {
          type: ADD_ADMIN_CONTENT_MANAGEMENTS,
          payload: contentManagements,
     };
};

export const fetchSystemAdminContentManagements = () => (dispatch) => {
     dispatch(setIsLoading(true));

     return callApi(API_SYSTEM_CONTENT_MANAGEMENTS, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(addSystemAdminContentManagements(response.data));
          })
          .finally(() => dispatch(setIsLoading(false)));
};

// Update
export const updateAdminUniversalContent = (contentManagementId, contentManagement) => {
     return {
          type: UPDATE_CONTENT_MANAGEMENT,
          payload: {
               contentManagementId,
               contentManagement,
          },
     };
};

export const updateAdminContentManagement = (contentManagementId, newContentManagement) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_CONTENT_MANAGEMENT.replace(':id', contentManagementId), 'PUT', newContentManagement)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(updateAdminUniversalContent(contentManagementId, response.data));
               dispatch(setShowPopupDetail(null));
               toast.success('Update successfully');
          })
          .finally(() => dispatch(setIsWaiting(false)));
};
